// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // backend_host: "localhost",
  // backend_port: "8080",
  // backend_proto: "http",
  backend_host: "api.whooosh.com",
  backend_port: "443",
  backend_proto: "https",
  backend_path:"/",
  frontend_path: "/",
  third_party_social_media_api_twitch_redirect_uri: "https://localhost:4200/",
  third_party_social_media_api_twitch_response_type: "token",
  third_party_social_media_api_twitch_scope: "user:edit+user:read:email",
  third_party_social_media_api_twitch_client_id: "ko11ck5x5zt53ds0i7djq58jsboxvu",
  third_party_social_media_api_twitch_url: "https://id.twitch.tv/oauth2/authorize",
  log_level: "DEBUG"
};

export const chat_service_location = "http://localhost:8081";

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
